import { Box, Stack } from "@mui/material";
import { Breadcrumb } from "../breadcrumb/Breadcrumb";
import { Outlet } from "react-router-dom";
import "./ContentPane.scss";
const ContenetPane = () => {
    return (
        <Box className='box-section-one' marginTop={7.5}>
            <Stack className='box-section-two' direction={"column"} justifyContent={"space-between"}>
                {/* <Box className="breadcrumb">
                    <Breadcrumb />
                </Box> */}
                <Box className="content-box">
                    <Stack direction={"column"}>
                        <Box className="content-scroll" width={'100%'} paddingInline={'10px'} marginBottom={'13px'}>
                        <Outlet />
                        </Box>
                    </Stack>
                </Box>
            </Stack>
        </Box>
    )
}



export default ContenetPane;

